import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import {  Menu, X } from 'lucide-react';
import '../assets/css/header.css';
import imagepro from '../assets/images/imagepro.png';

const links = [
    { to: '/', label: 'Home' },
    { to: '/projet', label: 'Projets' },
    { to: '/contact', label: 'Contact' },
    { to: '/CV', label: 'CV' },
];

const Header = () => {
    const location = useLocation();
    const [open, setOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 8);
        window.addEventListener('scroll', onScroll);
        return () => window.removeEventListener('scroll', onScroll);
    }, []);

    useEffect(() => setOpen(false), [location.pathname]);

    return (
        <>
            <nav className={`navbar ${scrolled ? 'is-scrolled' : ''}`}>
                <Link to="/" className="logo">
                    <img src={imagepro} alt="MCODEX" className="logo-img" />
                    <span>MCDX</span>
                    <span className="logo-dot" />
                </Link>

                <ul className="nav-links">
                    {links.map((link) => (
                        <li key={link.to}>
                            <Link
                                to={link.to}
                                className={location.pathname === link.to ? 'active' : ''}
                            >
                                {link.label}
                            </Link>
                        </li>
                    ))}
                </ul>

                <button
                    className="nav-toggle"
                    onClick={() => setOpen(!open)}
                    aria-label={open ? 'Fermer le menu' : 'Ouvrir le menu'}
                    aria-expanded={open}
                >
                    {open ? <X size={20} /> : <Menu size={20} />}
                </button>

                {open && (
                    <ul className="nav-links-mobile">
                        {links.map((link) => (
                            <li key={link.to}>
                                <Link
                                    to={link.to}
                                    className={location.pathname === link.to ? 'active' : ''}
                                >
                                    {link.label}
                                </Link>
                            </li>
                        ))}
                    </ul>
                )}
            </nav>
        </>
    );
};

export default Header;
